import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonForm, CommonFormComponent } from '../common-form/common-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { WorkspaceService } from '@workspaces/services/workspace.service';
import { Subscription } from 'rxjs';
import { EditWorkspaceRequest, Workspace } from '@workspaces/models/workspaces';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EditComponent } from '@workspaces/utils/edit-component';
import { Store } from '@ngrx/store';
import { workspaceListFeature, WorkspaceFetch } from '@workspaces/store/workspace-list.feature';
import { AppState } from 'src/app/state/app.state';

@Component({
  selector: 'app-edit-common-form',
  templateUrl: './edit-common-form.component.html',
  styleUrls: ['../../../global-workspace-styles.scss'],
  standalone: true,
  imports: [CommonFormComponent]
})
export class EditCommonFormComponent extends EditComponent implements OnInit, OnDestroy {
  constructor(
    protected override readonly route: ActivatedRoute,
    protected readonly workspaceService: WorkspaceService,
    protected override readonly snackbar: MatSnackBar,
    protected override readonly router: Router,
    private readonly store: Store<AppState>
  ) {
    super(route, snackbar, router);
  }

  private readonly sub = new Subscription();
  public currentWorkspace: Workspace | null = null;
  public isSubmitting = false;
  public override ngOnInit() {
    super.ngOnInit();
    if (this.workspaceId) {
      this.sub.add(
        this.store.select(workspaceListFeature.workspaceById(this.workspaceId)).subscribe(workspace => {
          if (workspace) {
            this.currentWorkspace = workspace;
          }
        })
      );
      this.store.dispatch(WorkspaceFetch({ workspaceId: this.workspaceId }));
    }
  }
  public onSubmit(commonFormValues: CommonForm) {
    this.isSubmitting = true;

    const mappedCommonForm: EditWorkspaceRequest = {
      description: commonFormValues.description,
      name: commonFormValues.name,
      ai_doc_info: commonFormValues.docAiInfo
    };
    this.sub.add(
      this.workspaceService.editWorkspace(this.workspaceId, mappedCommonForm).subscribe({
        error: () => {
          this.isSubmitting = false;
        },
        next: () => {
          this.isSubmitting = false;
          this.snackbar.open('Workspace was updated!', 'Dismiss', {
            duration: 5000,
            panelClass: ['success-snackbar']
          });
        }
      })
    );
  }

  public ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
